var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEatInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.632,
    height: 141.734,
    viewBox: "0 0 163.632 141.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DINE_IN_icon",
    "data-name": "DINE IN icon",
    transform: "translate(-2.457 -8.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2.457 8.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "svgFill",
    d: "M70.368,37.434l.689,1.722a2.237,2.237,0,0,0,2.066,1.377,1.552,1.552,0,0,0,.861-.172,2.461,2.461,0,0,0,1.205-2.927L74.5,35.712a3.172,3.172,0,0,1,.516-3.443,7.781,7.781,0,0,0,.516-8.953l-.861-1.377a2.126,2.126,0,0,0-3.615,2.238l.861,1.377a3.673,3.673,0,0,1-.172,3.96A7.126,7.126,0,0,0,70.368,37.434Z",
    transform: "translate(46.09 0.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "svgFill",
    d: "M76.268,37.434l.689,1.722a2.237,2.237,0,0,0,2.066,1.377,1.552,1.552,0,0,0,.861-.172,2.461,2.461,0,0,0,1.205-2.927L80.4,35.712a3.172,3.172,0,0,1,.516-3.443,7.781,7.781,0,0,0,.517-8.953l-.861-1.377a2.126,2.126,0,0,0-3.615,2.238l.861,1.377a3.673,3.673,0,0,1-.172,3.96A7.126,7.126,0,0,0,76.268,37.434Z",
    transform: "translate(50.348 0.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "svgFill",
    d: "M82.187,37.434l.689,1.722a2.237,2.237,0,0,0,2.066,1.377,1.552,1.552,0,0,0,.861-.172,2.461,2.461,0,0,0,1.205-2.927l-.689-1.722a3.172,3.172,0,0,1,.516-3.443,7.781,7.781,0,0,0,.517-8.953l-.861-1.377a2.126,2.126,0,0,0-3.615,2.238l.861,1.377a3.673,3.673,0,0,1-.172,3.96A6.84,6.84,0,0,0,82.187,37.434Z",
    transform: "translate(54.587 0.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "svgFill",
    d: "M74.164,49.951v2.927a1.177,1.177,0,0,0,1.205,1.205H96.718a1.177,1.177,0,0,0,1.205-1.205V49.951a16.657,16.657,0,0,0,8.264-13.945,1.177,1.177,0,0,0-1.205-1.205H67.105A1.177,1.177,0,0,0,65.9,36.005,16.657,16.657,0,0,0,74.164,49.951Z",
    transform: "translate(43.328 10.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "svgFill",
    d: "M121.451,50.1h-59.4a5.854,5.854,0,1,0,0,11.707H115.6v52.338a5.854,5.854,0,0,0,11.707,0V55.954A5.805,5.805,0,0,0,121.451,50.1Z",
    transform: "translate(36.327 21.735)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    className: "svgFill",
    cx: 16.872,
    cy: 16.872,
    r: 16.872,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, 38.27, 33.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "svgFill",
    d: "M58.313,93.969H34.038A11.666,11.666,0,0,1,22.5,84.327L14.066,37.154a5.828,5.828,0,0,0-6.714-4.821,5.959,5.959,0,0,0-4.821,6.714l8.264,47A23.594,23.594,0,0,0,33.865,105.5H54.009v21.349a5.854,5.854,0,1,0,11.707,0V101.544A7.283,7.283,0,0,0,58.313,93.969Z",
    transform: "translate(-2.457 8.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "svgFill",
    d: "M65.971,70.448H50.648l3.96-18.25,10.846,5.165a7.708,7.708,0,0,0,3.443.689h.344L85.6,57.363A7.724,7.724,0,0,0,93,49.272a7.83,7.83,0,0,0-8.092-7.4l-14.462.689S54.091,33.949,52.025,33.6c-2.238-.516-11.535-2.582-11.535-2.582a12.351,12.351,0,0,0-9.469,1.722,12.71,12.71,0,0,0-5.337,7.92L18.8,73.375a12.647,12.647,0,0,0,2.41,10.158,11.672,11.672,0,0,0,9.469,4.476h27.03a3.086,3.086,0,0,1,3.1,3.1v33.745a8.78,8.78,0,1,0,17.561,0V83.016A12.382,12.382,0,0,0,65.971,70.448Z",
    transform: "translate(9.168 7.757)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatInIcon);
export default __webpack_public_path__ + "static/media/eatInIcon.87ee359db059754b9a797ac94577f9c3.svg";
export { ForwardRef as ReactComponent };